// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productHeaderContainer[data-v-09a2a8dc] {\n  border-bottom: 1px solid #e0e0e0;\n}\n.productBodyItem[data-v-09a2a8dc] {\n  flex: 1 1 calc(50% - 10px);\n  box-sizing: border-box;\n}\n.productBodyItem .btn[data-v-09a2a8dc] {\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n/* .productContainer{\n    margin-top: 100px\n} */", ""]);
// Exports
module.exports = exports;
